<!-- eslint-disable arrow-body-style -->
<!-- eslint-disable prefer-const -->
<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable vue/no-unused-components -->
<script>
import CircleFirst from "@/svg/CircleFirst";
import BasicCircle from "@/svg/BasicCircle";

export default {
    name: "create",
    components: {
        BasicCircle,
        CircleFirst,
    },
    data() {
        return {
            hideMenu: true,
            serviceRoutes: [
                "Service",
                "Service ages",
                "Service location",
            ],
            fullScreenWidthRoutes: [
                "Listing type",
                "Simple venues",
                "Add venue",
                "Add event to venue",
                "Add dates",
                "Add holidays",
                "Add pricing",
                "Booking settings",
                "Simple event summary",

                "Service",
                "Service ages",
                "Service location",
                "Service availability",
                "Service pricing",
                "Tickets and price",
            ],
        };
    },
    methods: {},
    computed: {
        getRoute() {
            return this.$route.name;
        },
        getCurrentRouteNumber() {
            let routes = [];

            let type = "";

            if (this.$route.name === "Advanced Add Course"
                || this.$route.name === "Advanced Add Holiday"
                || this.$route.name === "Advanced Add Venue"
            ) {
                type = "advanced";
            }

            if (type === "advanced") {
                routes = [
                    "Advanced Add Course",
                    "Advanced Add Holiday",
                    "Advanced Add Venue",
                ];
            }

            if (type === "simple") {
                routes = [
                    "Welcome",
                    "Listing type",
                    "Listing details",
                    "Venues",
                    "Event schedule",
                ];
            }

            if (type === "weekly") {
                routes = [
                    "Welcome",
                    "Listing type",
                    "Listing details",
                    "Venues",
                    "Term dates",
                    "Class timetable",
                    "Pricing",
                ];
            }

            if (type === "daily") {
                routes = [
                    "Welcome",
                    "Listing type",
                    "Listing details",
                    "Venues",
                    "Course dates",
                    "Activity timetable",
                    "Pricing daily",
                ];
            }

            return routes.indexOf(this.$route.name) || 0;
        },
    },
    watch: {
        $route() {
            // List of routes for what we should show menu
            let routesWithMenu = [
                "Listing details",
                "Venues",
                "Event schedule",
                "Event dates & times",
                "Participants & pricing",
                "Term dates",
                "Class timetable",
                "Pricing",
                "Course dates",
                "Activity timetable",
                "Pricing daily",
                "Advanced Add Course",
                "Advanced Add Holiday",
                "Advanced Add Venue",
            ];

            this.hideMenu = routesWithMenu.indexOf(this.$route.name) === -1;
        },
    },
    mounted() {

    },
};
</script>

<template>
    <div class="row main-screen">
        <div v-if="!hideMenu" class="col-3 mt-4">
            <div class="navigation">
                <div
                    class="position-relative navigation-item"
                    :class="{
                        'active': getRoute === 'Advanced Add Course',
                        'checked': getCurrentRouteNumber === 0,
                    }"
                >
                    <basic-circle :checked="getCurrentRouteNumber >= 1"/>
                    Date range
                </div>
                <div
                    class="position-relative navigation-item"
                    :class="{
                        'active': getRoute === 'Advanced Add Holiday',
                        'checked': getCurrentRouteNumber > 2,
                    }"
                >
                    <basic-circle
                        :checked="getCurrentRouteNumber >= 2"
                        :show-default="getCurrentRouteNumber === 0"
                    />
                    Holidays
                </div>
                <div
                    class="position-relative navigation-item"
                    :class="{
                        'active': getRoute === 'Advanced Add Venue',
                        'checked': getCurrentRouteNumber > 3}"
                >
                    <basic-circle
                        :hide-line="true"
                        :checked="getCurrentRouteNumber > 3"
                        :show-default="getCurrentRouteNumber < 2"
                    />
                    Add a venue
                </div>
            </div>
        </div>
        <div :class="{
            'col-9 mt-4' : this.$route.name !== 'Welcome'
                && this.$route.name !== 'Listing type'
                && this.$route.name !== 'Summary',
            'col-10 mt-4': this.$route.name == 'Summary',
            'w-100': this.$route.name === 'Welcome',
            'col-12 mt-4': fullScreenWidthRoutes.includes(this.$route.name)
        }">
            <router-view/>
        </div>
        <!--    && serviceRoutes.indexOf(this.$route.name) !== -1-->
    </div>
    <notifications
        :duration="100000"
        position="left top"
        width="25%"
    />
</template>

<style scoped>
</style>
